"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinksDisplayGrid = exports.columns = exports.getRowHeight = exports.rowHeight = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var HeaderlessDisplayGrid_1 = require("./HeaderlessDisplayGrid");
exports.rowHeight = widgets_1.TabStyles.Typography.Sizing.XLarge;
function getRowHeight(rowCount, maxRows) {
    return Math.min((rowCount || 1), maxRows) * exports.rowHeight;
}
exports.getRowHeight = getRowHeight;
exports.columns = [
    function (_a) {
        var link = _a.link, name = _a.name, targetBlank = _a.targetBlank, useAnchor = _a.useAnchor;
        return ({
            name: 'name',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: '',
            cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkOrTextCellFormatter(function (rowData) { return rowData.name === null; }, function (rowData) { return name(rowData); }, function (urls, rowData) { return link(urls, rowData); }, true, targetBlank, useAnchor),
            sortable: false,
        });
    }
];
function LinksDisplayGrid(props) {
    var cols = exports.columns.map(function (columnFactory) { return columnFactory({
        link: props.link,
        name: props.name,
        targetBlank: props.targetBlank,
        useAnchor: props.useAnchor
    }); });
    return (React.createElement(HeaderlessDisplayGrid_1.HeaderlessDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, rowHeight: exports.rowHeight, renderErrors: data_catalog_shared_1.reportGraphQLErrors }));
}
exports.LinksDisplayGrid = LinksDisplayGrid;
//# sourceMappingURL=LinksDisplayGrid.js.map